import BaseModel from '@core/model';

import RatePlanTypeEnum from '@constants/enums/ratePlan/type';

export class RatePlanEntry extends BaseModel {
    static name = 'RatePlanEntry';
    static entity = 'ratePlanEntries';

    static fields() {
        return {
            ...super.fields(),
            id: this.attr(null),
            rate_plan_id: this.string(null).nullable(),
            type: this.enum(RatePlanTypeEnum).nullable(),
            from_amount: this.attr(this.defaultMoney).nullable(),
            to_amount: this.attr(this.defaultMoney).nullable(),
            from_quantity: this.number(null).nullable(),
            to_quantity: this.number(null).nullable(),
            rate: this.number(null).nullable(),
            charge: this.attr(this.defaultMoney).nullable(),
            split_rates: this.boolean(false),
            eis_rate: this.number(null).nullable(),
            vct_rate: this.number(null).nullable(),
            iht_rate: this.number(null).nullable(),
            pmi_rate: this.number(null).nullable()
        };
    }

    static mock(overrides = {}) {
        const ratePlanId = overrides.rate_plan_id || 'RATE-PLAN-ID';

        return {
            id: faker => faker.string.uuid(),
            rate_plan_id: () => ratePlanId,
            type: faker => faker.helpers.arrayElement(Object.values(RatePlanTypeEnum)),
            from_amount: () => ({ amount: 0, currency: 'GBP' }),
            to_amount: () => null,
            from_quantity: () => 0,
            to_quantity: () => null,
            rate: () => 0.25,
            charge: () => null,
            split_rates: () => false,
            eis_rate: () => null,
            vct_rate: () => null,
            iht_rate: () => null,
            pmi_rate: () => null
        };
    }
}

export default RatePlanEntry;
